<template>
    <b-modal v-model="showModal" title="Duplicate Tracker" modal-class="modal-w-md">

        <h6 class="heading6 mb-1">Tracker Name*</h6>
        <b-form-input class="form-control--mid mb-3" v-model="form.name"></b-form-input>

        <template v-if="trackerType === trackerTypes.PRIVATE">
            <div class="input-checkbox">
                <input id="copy-startups" type="checkbox" v-model="form.copy_startups">
                <label for="copy-startups">Include startups in tracker</label>
            </div>

            <div class="input-checkbox" v-if="form.copy_startups">
                <input id="copy-diligence-values" type="checkbox" v-model="form.copy_diligence_values">
                <label for="copy-diligence-values">Include Diligence Values</label>
            </div>

            <div v-if="$store.getters.isEnterprise && $store.getters.hasAgencyClients" class="input-checkbox">
                <input id="client" type="checkbox" v-model="showClients">
                <label for="client">Duplicate to client account</label>
            </div>

            <div v-if="$store.getters.isEcosystem && $store.getters.hasEventEnterprises" class="input-checkbox">
                <input id="client" type="checkbox" v-model="showClients">
                <label for="client">Duplicate to enterprise account</label>
            </div>
        </template>

        <template v-if="showClients">
            <ClientSelect
                v-if="$store.getters.isEnterprise"
                v-model="client"
                class="mt-2"
            />

            <EnterpriseSelect
                v-if="$store.getters.isEcosystem"
                v-model="client"
                class="mt-2"
            />
        </template>

        <template #modal-footer>
            <PrimaryButton
                :disabled="!canSave"
                caption="Create Duplicate Tracker"
                loading-caption="Creating Duplicate..."
                :loading="loading"
                @click="save"
            />
        </template>
    </b-modal>
</template>

<script>
import Vue from "vue";
import trackersService from "@/services/trackers.service";
import PrimaryButton from "@/components/ui/PrimaryButton.vue";
import {trackerTypes} from "@/constants/trackers";
import ClientSelect from "@/components/agencyClients/ClientSelect.vue";
import EnterpriseSelect from "@/components/eventEnterprises/EnterpriseSelect.vue";

export default {
    components: {EnterpriseSelect, ClientSelect, PrimaryButton},

    data() {
        return {
            id: 0,
            trackerType: null,

            form: {
                name: "",
                copy_startups: false,
                copy_diligence_values: false,
            },

            showClients: false,
            client: null,
            loading: false,
            showModal: false,
        }
    },

    computed: {
        trackerTypes() {
            return trackerTypes
        },

        canSave() {
            return this.form.name.length && (!this.showClients || this.client);
        },
    },

    methods: {
        open(id, name, trackerType) {
            this.id = id;
            this.trackerType = trackerType;
            this.showClients = false;
            this.client = null;
            this.form.name = "Duplicate of " + name;
            this.form.copy_startups = false;
            this.form.copy_diligence_values = false;

            if (this.$store.state.accountType !== 'premium') {
                trackersService.getCount().then(response => {
                    if (response.data >= this.constants.enterpriseLimits.trackers[this.$store.state.accountType]) {
                        this.showNeedUpgrade('trackers');
                    } else {
                        this.showModal = true;
                    }
                })
            } else {
                this.showModal = true;
            }
        },

        async save() {
            this.loading = true;

            let postData = {...this.form};

            if (this.showClients && this.client) {
                postData.client_id = this.client.id;
            }

            try {
                const {data} = await trackersService.duplicate(this.id, postData);

                if (data) {
                    let messageText = "New tracker created";

                    if (!this.client) {
                        let href = (this.trackerType === this.trackerTypes.PROJECT ? "/projects/" : "/trackers/") + data;

                        messageText += ": <a class='btn btn-outline-success btn-notify btn-lg ml-2' href='" + href + "' target='_blank'>" + this.form.name + "</a>";
                    }

                    Vue.notify({
                        group: 'app',
                        type: 'success',
                        duration: 10000,
                        text: messageText,
                    });

                    this.$emit('trackerSaved');
                } else {
                    Vue.notify({
                        group: 'app',
                        type: 'error',
                        duration: 10000,
                        text: "Tracker was not created",
                    });
            }} catch(e) {
                console.log(e.message);
            }

            this.loading = false;
            this.showModal = false;
        },
    }
}
</script>

<style scoped>

</style>
